// Module
var code = "<div class=bible> <div class=bibletext> <p> <span class=cwvnum>5</span>&nbsp;&nbsp;Which does not heed the voice of the charmers,&nbsp;<span class=redlight>&#149;</span><br/>&nbsp;&nbsp;&nbsp;and is deaf to the skilful weaver of spells.<br> </p> </div></div>";
// Exports
module.exports = code;